
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const sledge: Operator = {
	id: 'sledge',
	name: 'Sledge',
	role: 'Attacker',
	org: 'SAS',
	squad: 'REDHAMMER',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 1
	},
	meta: {
		gender: 'm',
		country: 'uk',
		season: 'Release',
		height: 192,
		weight: 95,
		price: {
			renown: 1000,
			r6credits: 0
		}
	},
	bio: {
		real_name: 'Seamus Cowden',
		birthplace: 'John O’groats, Scotland'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M161.5 287.667 239.093 305H45V45h260v128.832l-7.333 3.335-48-69.333 15.283 121.357-119.283-16.69 97.684 47.558z" style="opacity:.4"></path><path d="M192.84 277H73V73h204v73.996l-27.333-39.163L264.95 229.19 145.667 212.5l97.684 47.558z" style="fill:#906f79"></path><path d="M142.653 289.194 239.093 305l-48.968-20.604 72.292-23.924-98.146-40.826 107.979 16.41-17.083-114.087 41.302 62.687 8.219-9.239v23.229l18.649-60.077-24.879 29.223-68.959-112.724 30.689 169.088-201.57-36.309 171.34 72.174z" style="fill:#fff"></path><path d="m287.486 206.958 15.389 4.598-13.194 13.347zm-21.333 41.445 27.035-.247-13.924 22.705zm29.253 26.409s9.219 6.833 9.25 6.833.344-10.874.344-10.874zm-37.427 13.813 3.469 11-11.333-3.302z" style="fill:#fff"></path><path d="m214.389 132.056 9.375-9.375-28.451-28.451-9.375 9.375-13.248-13.248-6.023 6.727c-.732.874-3.261 3.675-7.639 4.583-3.889.807-7.096-.324-8.778-1.139a14 14 0 0 1-4.108-3.033l-7.585-4.94-26.172 26.172 29.215 29.215-68.599 68.599L73 273.445l97.052-97.052 21.107 21.107h14.675l29.389-29.389v-15.222z"></path><path d="m73.001 229.808 76.376-76.347 15.081 15.081L73 259.916zm66.887-125.252-14.27 14.27 69.257 69.257h7.153l23.917-23.917v-7.028l-52.985-52.985c-1.098 1.113-7.106 6.984-16.667 7.013-9.287.029-15.228-5.473-16.405-6.61" style="fill:#fff"></path><path d="M189.899 114.144h21.328v6.423h-21.328z" style="fill:#fff" transform="rotate(45.001 200.566 117.353)"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-sledge'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
